import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import * as Styles from './index.styles';

const { StyledProgress, StyledLabel, StyledBar } = Styles;

export const Progress = ({ value: valueProp, label, color, ...otherProps }) => {
    const [value, setValue] = useState(0);
    useEffect(() => {
        setValue(valueProp);
    }, [valueProp]);

    const normalizedValue = Math.min(Math.max(0, value), 1);

    return (
        <StyledProgress {...otherProps}>
            <StyledLabel>{label || `${Number.parseInt(normalizedValue * 100, 10)}%`}</StyledLabel>
            <StyledBar value={normalizedValue} color={color} />
        </StyledProgress>
    );
};

Progress.propTypes = {
    value: PropTypes.number,
    label: PropTypes.node,
    width: PropTypes.string,
    color: PropTypes.oneOf(['blue', 'green', 'red', 'yellow', 'orange']),
};

Progress.defaultProps = {
    value: 0,
    label: null,
    width: '300px',
    color: 'green',
};

StyledProgress.Styles = Styles;
